import { LvisionBetBoosterApiKeys } from '../types';

export const lvisionBetBoosterApiKeys: LvisionBetBoosterApiKeys = {
  prod: 'b14ky2n4m5x6ndo7z3b2f4oq',
  dev: 'y95b6aibi4n3xv5avcdqxlq9'
};
